import React from 'react';

const UserAddIcon = class extends React.Component {
	render() {
		return (
			<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" style={this.props.style||{}}>
				<path d="M9.36481,13.37427A1.2749,1.2749,0,0,1,10,11.62988V9c0-3,2-5,5.5-5a6.79133,6.79133,0,0,1,2.64575.50122,7.94842,7.94842,0,0,0,3.59918,8.26123,1.71227,1.71227,0,0,1-.10974.61182l-.28.75146a2.99115,2.99115,0,0,1-1.31073,1.462l-.66583,3.05176A2.99994,2.99994,0,0,1,16.44763,21H14.55237a2.99994,2.99994,0,0,1-2.931-2.36047l-.66583-3.05176a2.99143,2.99143,0,0,1-1.31073-1.462ZM32,6a6,6,0,1,1-6-6A6,6,0,0,1,32,6Zm-3-.5a.5.5,0,0,0-.5-.5H27V3.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V5H23.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H25V8.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V7h1.5a.5.5,0,0,0,.5-.5ZM26.06885,22.87207l-5.13623-2.7052A5.02336,5.02336,0,0,1,16.44727,23H14.55273a5.02379,5.02379,0,0,1-4.48553-2.833l-5.136,2.70508A1.57806,1.57806,0,0,0,4,24.23669V27a1,1,0,0,0,1,1H26a1,1,0,0,0,1-1V24.23669A1.57806,1.57806,0,0,0,26.06885,22.87207Z"/>
			</svg>
		);
	}
}

export default UserAddIcon;
